module.exports = __webpack_public_path__ + "img/hunjiashoushi.bfe1b85c.png";